import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import {
  useNavigate,
} from "react-router-dom";

import Select from "react-select";

import axios from "../axiosConfig";

import {
  customSelectStyles,
} from "../styles/reactSelectStyles";

import {
  FaArrowLeft,
  FaCreditCard,
  FaIndustry,
  FaMapMarkerAlt,
  FaPlus,
  FaSave,
  FaTrashAlt,
} from "react-icons/fa";

import {
  useTranslation,
} from "react-i18next";

import "../styles/CreateIndustry.css";

/* =========================================================
   Options
   ========================================================= */

const INDUSTRY_OPTIONS = [
  "Agriculture",
  "Automotive",
  "Construction",
  "Education",
  "Energy",
  "Financial Services",
  "Food & Beverage",
  "Healthcare",
  "Hospitality",
  "Logistics",
  "Manufacturing",
  "Media & Entertainment",
  "Mining",
  "Pharmaceuticals",
  "Real Estate",
  "Retail",
  "Technology",
  "Utilities",
  "Other",
];

const COUNTRY_OPTIONS = [
  {
    value: "Austria",
    key: "austria",
    code: "at",
  },
  {
    value: "Belgium",
    key: "belgium",
    code: "be",
  },
  {
    value: "Croatia",
    key: "croatia",
    code: "hr",
  },
  {
    value: "Czech Republic",
    key: "czech_republic",
    code: "cz",
  },
  {
    value: "Denmark",
    key: "denmark",
    code: "dk",
  },
  {
    value: "Estonia",
    key: "estonia",
    code: "ee",
  },
  {
    value: "Finland",
    key: "finland",
    code: "fi",
  },
  {
    value: "France",
    key: "france",
    code: "fr",
  },
  {
    value: "Germany",
    key: "germany",
    code: "de",
  },
  {
    value: "Hungary",
    key: "hungary",
    code: "hu",
  },
  {
    value: "Italy",
    key: "italy",
    code: "it",
  },
  {
    value: "Netherlands",
    key: "netherlands",
    code: "nl",
  },
  {
    value: "Norway",
    key: "norway",
    code: "no",
  },
  {
    value: "Poland",
    key: "poland",
    code: "pl",
  },
  {
    value: "Portugal",
    key: "portugal",
    code: "pt",
  },
  {
    value: "Spain",
    key: "spain",
    code: "es",
  },
  {
    value: "Sweden",
    key: "sweden",
    code: "se",
  },
  {
    value: "Switzerland",
    key: "switzerland",
    code: "ch",
  },
  {
    value: "United Kingdom",
    key: "united_kingdom",
    code: "gb",
  },
];

const PHONE_NUMBER_OPTIONS = [
  {
    value: "+43",
    key: "austria",
    code: "at",
  },
  {
    value: "+32",
    key: "belgium",
    code: "be",
  },
  {
    value: "+359",
    key: "bulgaria",
    code: "bg",
  },
  {
    value: "+385",
    key: "croatia",
    code: "hr",
  },
  {
    value: "+357",
    key: "cyprus",
    code: "cy",
  },
  {
    value: "+420",
    key: "czech_republic",
    code: "cz",
  },
  {
    value: "+45",
    key: "denmark",
    code: "dk",
  },
  {
    value: "+372",
    key: "estonia",
    code: "ee",
  },
  {
    value: "+358",
    key: "finland",
    code: "fi",
  },
  {
    value: "+33",
    key: "france",
    code: "fr",
  },
  {
    value: "+49",
    key: "germany",
    code: "de",
  },
  {
    value: "+30",
    key: "greece",
    code: "gr",
  },
  {
    value: "+36",
    key: "hungary",
    code: "hu",
  },
  {
    value: "+354",
    key: "iceland",
    code: "is",
  },
  {
    value: "+353",
    key: "ireland",
    code: "ie",
  },
  {
    value: "+39",
    key: "italy",
    code: "it",
  },
  {
    value: "+371",
    key: "latvia",
    code: "lv",
  },
  {
    value: "+370",
    key: "lithuania",
    code: "lt",
  },
  {
    value: "+352",
    key: "luxembourg",
    code: "lu",
  },
  {
    value: "+356",
    key: "malta",
    code: "mt",
  },
  {
    value: "+31",
    key: "netherlands",
    code: "nl",
  },
  {
    value: "+47",
    key: "norway",
    code: "no",
  },
  {
    value: "+48",
    key: "poland",
    code: "pl",
  },
  {
    value: "+351",
    key: "portugal",
    code: "pt",
  },
  {
    value: "+40",
    key: "romania",
    code: "ro",
  },
  {
    value: "+421",
    key: "slovakia",
    code: "sk",
  },
  {
    value: "+386",
    key: "slovenia",
    code: "si",
  },
  {
    value: "+34",
    key: "spain",
    code: "es",
  },
  {
    value: "+46",
    key: "sweden",
    code: "se",
  },
  {
    value: "+41",
    key: "switzerland",
    code: "ch",
  },
  {
    value: "+44",
    key: "united_kingdom",
    code: "gb",
  },
];

const CURRENCY_OPTIONS = [
  {
    value: "ALL",
    key: "all",
    code: "al",
  },
  {
    value: "BAM",
    key: "bam",
    code: "ba",
  },
  {
    value: "BGN",
    key: "bgn",
    code: "bg",
  },
  {
    value: "BYN",
    key: "byn",
    code: "by",
  },
  {
    value: "CHF",
    key: "chf",
    code: "ch",
  },
  {
    value: "CZK",
    key: "czk",
    code: "cz",
  },
  {
    value: "DKK",
    key: "dkk",
    code: "dk",
  },
  {
    value: "EUR",
    key: "eur",
    code: "eu",
  },
  {
    value: "GBP",
    key: "gbp",
    code: "gb",
  },
  {
    value: "HRK",
    key: "hrk",
    code: "hr",
  },
  {
    value: "HUF",
    key: "huf",
    code: "hu",
  },
  {
    value: "ISK",
    key: "isk",
    code: "is",
  },
  {
    value: "MKD",
    key: "mkd",
    code: "mk",
  },
  {
    value: "NOK",
    key: "nok",
    code: "no",
  },
  {
    value: "PLN",
    key: "pln",
    code: "pl",
  },
  {
    value: "RON",
    key: "ron",
    code: "ro",
  },
  {
    value: "RSD",
    key: "rsd",
    code: "rs",
  },
  {
    value: "RUB",
    key: "rub",
    code: "ru",
  },
  {
    value: "SEK",
    key: "sek",
    code: "se",
  },
  {
    value: "UAH",
    key: "uah",
    code: "ua",
  },
];

const PAYMENT_DUE_DATES = [
  {
    value: "same day",
    key: "same_day",
  },
  {
    value: "1 day",
    key: "d1",
  },
  {
    value: "3 days",
    key: "d3",
  },
  {
    value: "5 days",
    key: "d5",
  },
  {
    value: "10 days",
    key: "d10",
  },
  {
    value: "15 days",
    key: "d15",
  },
  {
    value: "30 days",
    key: "d30",
  },
  {
    value: "45 days",
    key: "d45",
  },
  {
    value: "60 days",
    key: "d60",
  },
  {
    value: "90 days",
    key: "d90",
  },
  {
    value: "120 days",
    key: "d120",
  },
];

const DEFAULT_FORM_DATA = {
  companyName: "",
  industryType: "",
  otherIndustry: "",

  /*
   * Mantidos para compatibilidade com
   * backend/model.
   */
  goodsProduced: "",
  productionCapacity: "",
  avgShippingVolumePerMonth: "",
  transportationNeeds: "",
  currentTransportProviders: "",
  frequentDestinations: "",
  specialRequirements: "",

  address: "",
  city: "",
  postalCode: "",
  country: "",

  mainContactName: "",
  mainContactTitle: "",
  contactEmail: "",
  invoiceEmail: "",
  phoneNumberCountryCode: "",
  phoneNumber: "",
  contacts: [],
  website: "",

  bankName: "",
  accountHolderName: "",
  accountNumber: "",
  IBAN: "",
  SWIFT_BIC: "",
  currency: "",

  paymentMethodsAccepted: [],
  paymentDueDate: "",
  discountTerms: "",
  latePaymentPenalties: "",

  iva: "",
  VAT_TaxInformation: "",
  invoiceDeliveryMethod: "",

  additionalNotes: "",
};

/* =========================================================
   Helpers
   ========================================================= */

const countOnlyAlphaNumeric = (
  value = ""
) =>
  String(value).replace(
    /[^a-zA-Z0-9]/g,
    ""
  ).length;

/* =========================================================
   CreateIndustry
   ========================================================= */

export default function CreateIndustry() {
  const {
    t,
  } = useTranslation(
    "create_industry"
  );

  const navigate =
    useNavigate();

  const sectionRefs =
    useRef({});

  const [
    activeSection,
    setActiveSection,
  ] = useState(
    "basic"
  );

  const [
    formData,
    setFormData,
  ] = useState(
    DEFAULT_FORM_DATA
  );

  const [
    formErrors,
    setFormErrors,
  ] = useState({});

  const [
    errorMessage,
    setErrorMessage,
  ] = useState("");

  const [
    showSuccessPopup,
    setShowSuccessPopup,
  ] = useState(false);

  const [
    createdIndustryName,
    setCreatedIndustryName,
  ] = useState("");

  const [
    isSaving,
    setIsSaving,
  ] = useState(false);

  /* =======================================================
     Translated options
     ======================================================= */

  const industryTypeOptions =
    useMemo(
      () =>
        INDUSTRY_OPTIONS.map(
          (
            value
          ) => ({
            value,

            label:
              t(
                `options.industry.${value}`
              ),
          })
        ),
      [t]
    );

  const countryOptions =
    useMemo(
      () =>
        COUNTRY_OPTIONS.map(
          (
            option
          ) => ({
            ...option,

            label:
              t(
                `countries.${option.key}`
              ),
          })
        ),
      [t]
    );

  const phoneNumberOptions =
    useMemo(
      () =>
        PHONE_NUMBER_OPTIONS.map(
          (
            option
          ) => ({
            ...option,

            label:
              `${t(
                `countries.${option.key}`
              )} (${option.value})`,
          })
        ),
      [t]
    );

  const currencyOptions =
    useMemo(
      () =>
        CURRENCY_OPTIONS.map(
          (
            option
          ) => ({
            ...option,

            label:
              t(
                `currencies.${option.key}`
              ),
          })
        ),
      [t]
    );

  const paymentOptions =
    useMemo(
      () => [
        {
          value:
            "Bank Transfer",

          label:
            t(
              "payments.bank_transfer"
            ),
        },
        {
          value:
            "Credit/Debit Card",

          label:
            t(
              "payments.card"
            ),
        },
        {
          value:
            "Cash",

          label:
            t(
              "payments.cash"
            ),
        },
        {
          value:
            "MB WAY",

          label:
            t(
              "payments.mbway"
            ),
        },
        {
          value:
            "PayPal",

          label:
            t(
              "payments.paypal"
            ),
        },
      ],
      [t]
    );

  const paymentDueDateOptions =
    useMemo(
      () =>
        PAYMENT_DUE_DATES.map(
          (
            option
          ) => ({
            value:
              option.value,

            label:
              t(
                `dueOptions.${option.key}`
              ),
          })
        ),
      [t]
    );

  const invoiceDeliveryOptions =
    useMemo(
      () => [
        {
          value:
            "email",

          label:
            t(
              "invoice_delivery.email"
            ),
        },
        {
          value:
            "postal",

          label:
            t(
              "invoice_delivery.postal"
            ),
        },
        {
          value:
            "download",

          label:
            t(
              "invoice_delivery.download"
            ),
        },
      ],
      [t]
    );

  const multiInlineScrollStyles =
    useMemo(
      () => {
        const base =
          customSelectStyles ||
          {};

        return {
          ...base,

          control: (
            provided,
            state
          ) => ({
            ...(base.control
              ? base.control(
                  provided,
                  state
                )
              : provided),

            minHeight: 40,
            height: 40,
            overflow:
              "hidden",

            alignItems:
              "center",
          }),

          valueContainer: (
            provided,
            state
          ) => ({
            ...(base.valueContainer
              ? base.valueContainer(
                  provided,
                  state
                )
              : provided),

            flexWrap:
              "nowrap",

            overflowX:
              "auto",

            overflowY:
              "hidden",

            whiteSpace:
              "nowrap",

            alignItems:
              "center",

            paddingRight:
              68,

            gap: 5,
          }),

          multiValue: (
            provided,
            state
          ) => ({
            ...(base.multiValue
              ? base.multiValue(
                  provided,
                  state
                )
              : provided),

            flex:
              "0 0 auto",

            maxWidth:
              "none",

            margin: 0,
          }),

          multiValueLabel: (
            provided,
            state
          ) => ({
            ...(base.multiValueLabel
              ? base.multiValueLabel(
                  provided,
                  state
                )
              : provided),

            maxWidth:
              140,

            overflow:
              "hidden",

            textOverflow:
              "ellipsis",

            whiteSpace:
              "nowrap",
          }),
        };
      },
      []
    );

  /* =======================================================
     Scroll spy
     ======================================================= */

  useEffect(() => {
    const sectionKeys = [
      "basic",
      "contacts",
      "billing",
    ];

    let animationFrameId =
      null;

    const updateActiveSection =
      () => {
        animationFrameId =
          null;

        const activationLine =
          190;

        let nextActive =
          "basic";

        for (
          let index = 0;
          index <
          sectionKeys.length;
          index += 1
        ) {
          const key =
            sectionKeys[index];

          const section =
            sectionRefs.current[
              key
            ];

          if (!section) {
            continue;
          }

          const rect =
            section.getBoundingClientRect();

          if (
            rect.top <=
            activationLine
          ) {
            nextActive =
              key;
          } else {
            break;
          }
        }

        setActiveSection(
          (
            current
          ) =>
            current ===
            nextActive
              ? current
              : nextActive
        );
      };

    const scheduleUpdate =
      () => {
        if (
          animationFrameId !==
          null
        ) {
          return;
        }

        animationFrameId =
          window.requestAnimationFrame(
            updateActiveSection
          );
      };

    document.addEventListener(
      "scroll",
      scheduleUpdate,
      true
    );

    window.addEventListener(
      "resize",
      scheduleUpdate
    );

    updateActiveSection();

    return () => {
      document.removeEventListener(
        "scroll",
        scheduleUpdate,
        true
      );

      window.removeEventListener(
        "resize",
        scheduleUpdate
      );

      if (
        animationFrameId !==
        null
      ) {
        window.cancelAnimationFrame(
          animationFrameId
        );
      }
    };
  }, []);

  const scrollToSection =
    (
      sectionKey
    ) => {
      setActiveSection(
        sectionKey
      );

      sectionRefs.current[
        sectionKey
      ]?.scrollIntoView({
        behavior:
          "smooth",

        block:
          "start",
      });
    };

  /* =======================================================
     Field helpers
     ======================================================= */

  const clearFieldError =
    (
      fieldName
    ) => {
      setFormErrors(
        (
          previous
        ) => {
          if (
            !previous[
              fieldName
            ]
          ) {
            return previous;
          }

          const updated = {
            ...previous,
          };

          delete updated[
            fieldName
          ];

          return updated;
        }
      );
    };

  const setFieldValue =
    (
      fieldName,
      value
    ) => {
      setFormData(
        (
          previous
        ) => ({
          ...previous,

          [fieldName]:
            value,
        })
      );

      clearFieldError(
        fieldName
      );
    };

  const handleInputChange =
    (
      event
    ) => {
      const {
        name,
        value,
      } = event.target;

      if (
        name ===
        "iva"
      ) {
        const cleaned =
          value
            .replace(
              ",",
              "."
            )
            .replace(
              /[^0-9.]/g,
              ""
            );

        setFormData(
          (
            previous
          ) => ({
            ...previous,

            iva:
              cleaned,
          })
        );

        setFormErrors(
          (
            previous
          ) => {
            const updated = {
              ...previous,
            };

            if (
              !String(
                cleaned
              ).trim()
            ) {
              delete updated.iva;

              return updated;
            }

            const parsed =
              Number(
                cleaned
              );

            if (
              !Number.isFinite(
                parsed
              ) ||
              parsed < 0 ||
              parsed > 100
            ) {
              updated.iva =
                t(
                  "errors.iva_invalid"
                );
            } else {
              delete updated.iva;
            }

            return updated;
          }
        );

        return;
      }

      setFormData(
        (
          previous
        ) => ({
          ...previous,

          [name]:
            value,
        })
      );

      if (
        name ===
        "IBAN"
      ) {
        setFormErrors(
          (
            previous
          ) => {
            const updated = {
              ...previous,
            };

            if (
              !String(
                value
              ).trim()
            ) {
              delete updated.IBAN;
            } else if (
              countOnlyAlphaNumeric(
                value
              ) < 15
            ) {
              updated.IBAN =
                t(
                  "errors.IBAN_min"
                );
            } else {
              delete updated.IBAN;
            }

            return updated;
          }
        );

        return;
      }

      if (
        name ===
        "SWIFT_BIC"
      ) {
        setFormErrors(
          (
            previous
          ) => {
            const updated = {
              ...previous,
            };

            if (
              !String(
                value
              ).trim()
            ) {
              delete updated.SWIFT_BIC;
            } else if (
              countOnlyAlphaNumeric(
                value
              ) < 8
            ) {
              updated.SWIFT_BIC =
                t(
                  "errors.SWIFT_BIC_min"
                );
            } else {
              delete updated.SWIFT_BIC;
            }

            return updated;
          }
        );

        return;
      }

      clearFieldError(
        name
      );
    };

  /* =======================================================
     Additional contacts
     ======================================================= */

  const handleAddContact =
    () => {
      setFormData(
        (
          previous
        ) => ({
          ...previous,

          contacts: [
            ...(previous.contacts ||
              []),

            {
              contactName:
                "",

              contactTitle:
                "",

              contactEmail:
                "",

              phoneNumberCountryCode:
                "",

              phoneNumber:
                "",
            },
          ],
        })
      );
    };

  const handleRemoveContact =
    (
      index
    ) => {
      setFormData(
        (
          previous
        ) => ({
          ...previous,

          contacts: (
            previous.contacts ||
            []
          ).filter(
            (
              _,
              contactIndex
            ) =>
              contactIndex !==
              index
          ),
        })
      );

      setFormErrors(
        (
          previous
        ) => {
          const updated = {
            ...previous,
          };

          Object.keys(
            updated
          ).forEach(
            (
              key
            ) => {
              if (
                key.startsWith(
                  `contacts-${index}-`
                )
              ) {
                delete updated[
                  key
                ];
              }
            }
          );

          return updated;
        }
      );
    };

  const handleContactChange =
    (
      index,
      field,
      value
    ) => {
      setFormData(
        (
          previous
        ) => ({
          ...previous,

          contacts: (
            previous.contacts ||
            []
          ).map(
            (
              contact,
              contactIndex
            ) =>
              contactIndex ===
              index
                ? {
                    ...contact,

                    [field]:
                      value,
                  }
                : contact
          ),
        })
      );

      setFormErrors(
        (
          previous
        ) => {
          const updated = {
            ...previous,
          };

          delete updated[
            `contacts-${index}-${field}`
          ];

          if (
            field ===
            "contactEmail"
          ) {
            Object.keys(
              updated
            ).forEach(
              (
                key
              ) => {
                if (
                  key.startsWith(
                    "contacts-"
                  ) &&
                  key.endsWith(
                    "-contactEmail"
                  )
                ) {
                  delete updated[
                    key
                  ];
                }
              }
            );
          }

          return updated;
        }
      );
    };

  /* =======================================================
     Validation
     ======================================================= */

  const validateAll =
    () => {
      const errors = {};

      if (
        !String(
          formData.companyName ||
            ""
        ).trim()
      ) {
        errors.companyName =
          t(
            "errors.companyName"
          );
      }

      if (
        String(
          formData.IBAN ||
            ""
        ).trim() &&
        countOnlyAlphaNumeric(
          formData.IBAN
        ) < 15
      ) {
        errors.IBAN =
          t(
            "errors.IBAN_min"
          );
      }

      if (
        String(
          formData.SWIFT_BIC ||
            ""
        ).trim() &&
        countOnlyAlphaNumeric(
          formData.SWIFT_BIC
        ) < 8
      ) {
        errors.SWIFT_BIC =
          t(
            "errors.SWIFT_BIC_min"
          );
      }

      if (
        String(
          formData.iva ||
            ""
        ).trim()
      ) {
        const parsedIva =
          Number(
            String(
              formData.iva
            ).replace(
              ",",
              "."
            )
          );

        if (
          !Number.isFinite(
            parsedIva
          ) ||
          parsedIva < 0 ||
          parsedIva > 100
        ) {
          errors.iva =
            t(
              "errors.iva_invalid"
            );
        }
      }

      const normalizedEmailMap =
        {};

      (
        formData.contacts ||
        []
      ).forEach(
        (
          contact,
          index
        ) => {
          const email =
            String(
              contact.contactEmail ||
                ""
            )
              .trim()
              .toLowerCase();

          if (!email) {
            return;
          }

          if (
            !normalizedEmailMap[
              email
            ]
          ) {
            normalizedEmailMap[
              email
            ] = [];
          }

          normalizedEmailMap[
            email
          ].push(index);
        }
      );

      Object.values(
        normalizedEmailMap
      ).forEach(
        (
          indexes
        ) => {
          if (
            indexes.length >
            1
          ) {
            indexes.forEach(
              (
                index
              ) => {
                errors[
                  `contacts-${index}-contactEmail`
                ] =
                  t(
                    "errors.duplicate_contact_email"
                  );
              }
            );
          }
        }
      );

      return errors;
    };

  const getSectionFromErrors =
    (
      errors
    ) => {
      const keys =
        Object.keys(
          errors
        );

      if (
        keys.length ===
        0
      ) {
        return null;
      }

      if (
        keys.some(
          (
            key
          ) =>
            key ===
              "companyName" ||
            key ===
              "industryType" ||
            key ===
              "otherIndustry"
        )
      ) {
        return "basic";
      }

      if (
        keys.some(
          (
            key
          ) =>
            key.startsWith(
              "contacts-"
            ) ||
            [
              "address",
              "city",
              "postalCode",
              "country",
              "mainContactName",
              "mainContactTitle",
              "contactEmail",
              "invoiceEmail",
              "phoneNumberCountryCode",
              "phoneNumber",
              "website",
            ].includes(
              key
            )
        )
      ) {
        return "contacts";
      }

      return "billing";
    };

  /* =======================================================
     Submit
     ======================================================= */

  const handleSubmit =
    async (
      event
    ) => {
      event.preventDefault();

      if (
        isSaving
      ) {
        return;
      }

      setErrorMessage(
        ""
      );

      const errors =
        validateAll();

      setFormErrors(
        errors
      );

      if (
        Object.keys(
          errors
        ).length >
        0
      ) {
        setErrorMessage(
          t(
            "messages.fill_required"
          )
        );

        const section =
          getSectionFromErrors(
            errors
          );

        if (section) {
          setTimeout(
            () => {
              scrollToSection(
                section
              );
            },
            0
          );
        }

        return;
      }

      setIsSaving(
        true
      );

      try {
        const payload = {
          ...formData,

          iva:
            String(
              formData.iva ||
                ""
            ).trim()
              ? Number(
                  String(
                    formData.iva
                  ).replace(
                    ",",
                    "."
                  )
                ).toFixed(
                  2
                )
              : null,

          contacts:
            formData.contacts ||
            [],
        };

        const {
          data,
        } =
          await axios.post(
            "/industries",
            payload
          );

        setCreatedIndustryName(
          data?.companyName ||
            formData.companyName ||
            ""
        );

        setShowSuccessPopup(
          true
        );

        setTimeout(() => {
          navigate(
            "/clients/industry?view=industries"
          );
        }, 1200);
      } catch (error) {
        console.error(
          "Error creating industry:",
          error
        );

        setIsSaving(
          false
        );

        setShowSuccessPopup(
          false
        );

        setErrorMessage(
          error.response
            ?.data
            ?.error ||
            t(
              "messages.create_error_fallback"
            )
        );
      }
    };

  /* =======================================================
     Navigation
     ======================================================= */

  const navigationItems =
    useMemo(
      () => [
        {
          key:
            "basic",

          icon:
            <FaIndustry />,

          title:
            t(
              "nav.basic"
            ),

          subtitle:
            t(
              "nav.basic_subtitle"
            ),
        },
        {
          key:
            "contacts",

          icon:
            <FaMapMarkerAlt />,

          title:
            t(
              "nav.contacts"
            ),

          subtitle:
            t(
              "nav.contacts_subtitle"
            ),
        },
        {
          key:
            "billing",

          icon:
            <FaCreditCard />,

          title:
            t(
              "nav.billing"
            ),

          subtitle:
            t(
              "nav.billing_subtitle"
            ),
        },
      ],
      [t]
    );

  /* =======================================================
     Render
     ======================================================= */

  return (
    <div className="create-industry-page">
      {showSuccessPopup && (
        <div className="create-industry-successPopup-overlay">
          <div className="create-industry-successPopup">
            <div className="create-industry-successPopup-icon">
              ✓
            </div>

            <h3>
              {t(
                "success.createdTitle"
              )}
            </h3>

            <p>
              {t(
                "success.created",
                {
                  name:
                    createdIndustryName,
                }
              )}
            </p>

            <button
              type="button"
              className="create-industry-successPopup-btn"
              onClick={() =>
                navigate(
                  "/clients/industry?view=industries"
                )
              }
            >
              {t(
                "actions.ok"
              )}
            </button>
          </div>
        </div>
      )}

      <header className="create-industry-header">
        <div className="create-industry-header__left">
          <button
            type="button"
            className="create-industry-back-button"
            onClick={() =>
              navigate(
                "/clients/industry?view=industries"
              )
            }
            aria-label={t(
              "actions.back"
            )}
          >
            <FaArrowLeft />
          </button>

          <div className="create-industry-header__copy">
            <h1>
              {t(
                "header.title"
              )}
            </h1>

            <p>
              {t(
                "header.subtitle"
              )}
            </p>
          </div>
        </div>

        <div className="create-industry-header__actions">
          <button
            type="button"
            className="create-industry-header-cancel"
            onClick={() =>
              navigate(
                "/clients/industry?view=industries"
              )
            }
          >
            {t(
              "buttons.cancel"
            )}
          </button>

          <button
            type="submit"
            form="create-industry-main-form"
            className="create-industry-header-save"
            disabled={
              isSaving
            }
          >
            <FaSave />

            <span>
              {isSaving
                ? t(
                    "buttons.creating"
                  )
                : t(
                    "buttons.create"
                  )}
            </span>
          </button>
        </div>
      </header>

      {errorMessage && (
        <div className="create-industry-global-error">
          {
            errorMessage
          }
        </div>
      )}

      <div className="create-industry-layout">
        <aside className="create-industry-section-nav">
          <div className="create-industry-section-nav__inner">
            {navigationItems.map(
              (
                item
              ) => (
                <button
                  type="button"
                  key={
                    item.key
                  }
                  className={`create-industry-section-nav__item ${
                    activeSection ===
                    item.key
                      ? "is-active"
                      : ""
                  }`}
                  onClick={() =>
                    scrollToSection(
                      item.key
                    )
                  }
                >
                  <span className="create-industry-section-nav__icon">
                    {
                      item.icon
                    }
                  </span>

                  <span className="create-industry-section-nav__copy">
                    <strong>
                      {
                        item.title
                      }
                    </strong>

                    <small>
                      {
                        item.subtitle
                      }
                    </small>
                  </span>
                </button>
              )
            )}
          </div>
        </aside>

        <form
          id="create-industry-main-form"
          className="create-industry-form"
          onSubmit={
            handleSubmit
          }
          noValidate
        >
          {/* =========================================
              BASIC INFORMATION
              ========================================= */}
          <section
            ref={(
              node
            ) => {
              sectionRefs.current.basic =
                node;
            }}
            data-section="basic"
            className="create-industry-section"
          >
            <div className="create-industry-section-header">
              <span className="create-industry-section-header__icon">
                <FaIndustry />
              </span>

              <div>
                <h2>
                  {t(
                    "nav.basic"
                  )}
                </h2>

                <p>
                  {t(
                    "section_subtitles.basic"
                  )}
                </p>
              </div>
            </div>

            <div className="create-industry-grid create-industry-grid--2">
              <div className="create-industry-field">
                <label htmlFor="companyName">
                  {t(
                    "labels.companyName"
                  )}
                  *
                </label>

                <input
                  type="text"
                  id="companyName"
                  name="companyName"
                  value={
                    formData.companyName
                  }
                  onChange={
                    handleInputChange
                  }
                  placeholder={t(
                    "placeholders.companyName"
                  )}
                  className={`create-industry-input ${
                    formErrors.companyName
                      ? "create-industry-input-error"
                      : ""
                  }`}
                />

                {formErrors.companyName && (
                  <p className="create-industry-field-error">
                    {
                      formErrors.companyName
                    }
                  </p>
                )}
              </div>

              <div className="create-industry-field">
                <label>
                  {t(
                    "labels.industryType"
                  )}
                </label>

                <Select
                  options={
                    industryTypeOptions
                  }
                  value={
                    industryTypeOptions.find(
                      (
                        option
                      ) =>
                        option.value ===
                        formData.industryType
                    ) ||
                    null
                  }
                  onChange={(
                    option
                  ) => {
                    setFieldValue(
                      "industryType",
                      option?.value ||
                        ""
                    );

                    if (
                      option?.value !==
                      "Other"
                    ) {
                      setFieldValue(
                        "otherIndustry",
                        ""
                      );
                    }
                  }}
                  placeholder={t(
                    "placeholders.industryType"
                  )}
                  styles={
                    customSelectStyles
                  }
                  classNamePrefix={
                    formErrors.industryType
                      ? "create-industry-select-error"
                      : "create-industry-select"
                  }
                  isClearable
                />
              </div>
            </div>

            {formData.industryType ===
              "Other" && (
              <div className="create-industry-grid create-industry-grid--1">
                <div className="create-industry-field">
                  <label htmlFor="otherIndustry">
                    {t(
                      "labels.otherIndustry"
                    )}
                  </label>

                  <input
                    type="text"
                    id="otherIndustry"
                    name="otherIndustry"
                    value={
                      formData.otherIndustry
                    }
                    onChange={
                      handleInputChange
                    }
                    placeholder={t(
                      "placeholders.otherIndustry"
                    )}
                    className="create-industry-input"
                  />
                </div>
              </div>
            )}
          </section>

          {/* =========================================
              ADDRESS & CONTACTS
              ========================================= */}
          <section
            ref={(
              node
            ) => {
              sectionRefs.current.contacts =
                node;
            }}
            data-section="contacts"
            className="create-industry-section"
          >
            <div className="create-industry-section-header">
              <span className="create-industry-section-header__icon">
                <FaMapMarkerAlt />
              </span>

              <div>
                <h2>
                  {t(
                    "nav.contacts"
                  )}
                </h2>

                <p>
                  {t(
                    "section_subtitles.contacts"
                  )}
                </p>
              </div>
            </div>

            <div className="create-industry-grid create-industry-grid--1">
              <div className="create-industry-field">
                <label htmlFor="address">
                  {t(
                    "labels.address"
                  )}
                </label>

                <input
                  type="text"
                  id="address"
                  name="address"
                  value={
                    formData.address
                  }
                  onChange={
                    handleInputChange
                  }
                  placeholder={t(
                    "placeholders.address"
                  )}
                  className="create-industry-input"
                />
              </div>
            </div>

            <div className="create-industry-grid create-industry-grid--3">
              <div className="create-industry-field">
                <label htmlFor="city">
                  {t(
                    "labels.city"
                  )}
                </label>

                <input
                  type="text"
                  id="city"
                  name="city"
                  value={
                    formData.city
                  }
                  onChange={
                    handleInputChange
                  }
                  placeholder={t(
                    "placeholders.city"
                  )}
                  className="create-industry-input"
                />
              </div>

              <div className="create-industry-field">
                <label htmlFor="postalCode">
                  {t(
                    "labels.postalCode"
                  )}
                </label>

                <input
                  type="text"
                  id="postalCode"
                  name="postalCode"
                  value={
                    formData.postalCode
                  }
                  onChange={
                    handleInputChange
                  }
                  placeholder={t(
                    "placeholders.postalCode"
                  )}
                  className="create-industry-input"
                />
              </div>

              <div className="create-industry-field">
                <label>
                  {t(
                    "labels.country"
                  )}
                </label>

                <Select
                  options={
                    countryOptions
                  }
                  value={
                    countryOptions.find(
                      (
                        option
                      ) =>
                        option.value ===
                        formData.country
                    ) ||
                    null
                  }
                  onChange={(
                    option
                  ) =>
                    setFieldValue(
                      "country",
                      option?.value ||
                        ""
                    )
                  }
                  formatOptionLabel={(
                    option
                  ) => (
                    <div className="create-industry-option-with-icon">
                      <img
                        src={`https://flagcdn.com/w40/${option.code}.png`}
                        alt={
                          option.label
                        }
                        className="create-industry-option-flag"
                      />

                      <span>
                        {
                          option.label
                        }
                      </span>
                    </div>
                  )}
                  placeholder={t(
                    "placeholders.country"
                  )}
                  styles={
                    customSelectStyles
                  }
                  classNamePrefix="create-industry-select"
                  isClearable
                />
              </div>
            </div>

            <div className="create-industry-grid create-industry-grid--1">
              <div className="create-industry-field">
                <label htmlFor="website">
                  {t(
                    "labels.website"
                  )}
                </label>

                <input
                  type="url"
                  id="website"
                  name="website"
                  value={
                    formData.website
                  }
                  onChange={
                    handleInputChange
                  }
                  placeholder={t(
                    "placeholders.website"
                  )}
                  className="create-industry-input"
                />
              </div>
            </div>

            <div className="create-industry-grid create-industry-grid--2">
              <div className="create-industry-field">
                <label htmlFor="mainContactName">
                  {t(
                    "labels.mainContactName"
                  )}
                </label>

                <input
                  type="text"
                  id="mainContactName"
                  name="mainContactName"
                  value={
                    formData.mainContactName
                  }
                  onChange={
                    handleInputChange
                  }
                  placeholder={t(
                    "placeholders.mainContactName"
                  )}
                  className="create-industry-input"
                />
              </div>

              <div className="create-industry-field">
                <label htmlFor="mainContactTitle">
                  {t(
                    "labels.mainContactTitle"
                  )}
                </label>

                <input
                  type="text"
                  id="mainContactTitle"
                  name="mainContactTitle"
                  value={
                    formData.mainContactTitle
                  }
                  onChange={
                    handleInputChange
                  }
                  placeholder={t(
                    "placeholders.mainContactTitle"
                  )}
                  className="create-industry-input"
                />
              </div>
            </div>

            <div className="create-industry-grid create-industry-grid--3">
              <div className="create-industry-field">
                <label htmlFor="contactEmail">
                  {t(
                    "labels.contactEmail"
                  )}
                </label>

                <input
                  type="email"
                  id="contactEmail"
                  name="contactEmail"
                  value={
                    formData.contactEmail
                  }
                  onChange={
                    handleInputChange
                  }
                  placeholder={t(
                    "placeholders.contactEmail"
                  )}
                  className="create-industry-input"
                />
              </div>

              <div className="create-industry-field">
                <label>
                  {t(
                    "labels.phoneNumberCountryCode"
                  )}
                </label>

                <Select
                  options={
                    phoneNumberOptions
                  }
                  value={
                    phoneNumberOptions.find(
                      (
                        option
                      ) =>
                        option.value ===
                        formData.phoneNumberCountryCode
                    ) ||
                    null
                  }
                  onChange={(
                    option
                  ) =>
                    setFieldValue(
                      "phoneNumberCountryCode",
                      option?.value ||
                        ""
                    )
                  }
                  formatOptionLabel={(
                    option
                  ) => (
                    <div className="create-industry-option-with-icon">
                      <img
                        src={`https://flagcdn.com/w40/${option.code}.png`}
                        alt={
                          option.label
                        }
                        className="create-industry-option-flag"
                      />

                      <span>
                        {
                          option.label
                        }
                      </span>
                    </div>
                  )}
                  placeholder={t(
                    "placeholders.phoneNumberCountryCode"
                  )}
                  styles={
                    customSelectStyles
                  }
                  classNamePrefix="create-industry-select"
                  isClearable
                />
              </div>

              <div className="create-industry-field">
                <label htmlFor="phoneNumber">
                  {t(
                    "labels.phoneNumber"
                  )}
                </label>

                <input
                  type="text"
                  id="phoneNumber"
                  name="phoneNumber"
                  value={
                    formData.phoneNumber
                  }
                  onChange={
                    handleInputChange
                  }
                  placeholder={t(
                    "placeholders.phoneNumber"
                  )}
                  className="create-industry-input"
                />
              </div>
            </div>

            <div className="create-industry-grid create-industry-grid--1">
              <div className="create-industry-field">
                <label htmlFor="invoiceEmail">
                  {t(
                    "labels.invoiceEmail"
                  )}
                </label>

                <input
                  type="email"
                  id="invoiceEmail"
                  name="invoiceEmail"
                  value={
                    formData.invoiceEmail
                  }
                  onChange={
                    handleInputChange
                  }
                  placeholder={t(
                    "placeholders.invoiceEmail"
                  )}
                  className="create-industry-input"
                />
              </div>
            </div>

            <div className="create-industry-subsection-header">
              <div>
                <h3>
                  {t(
                    "contacts.section_title"
                  )}
                </h3>

                <p>
                  {t(
                    "contacts.section_subtitle"
                  )}
                </p>
              </div>

              <button
                type="button"
                className="create-industry-add-user-button"
                onClick={
                  handleAddContact
                }
              >
                <FaPlus />

                <span>
                  {t(
                    "contacts.actions.add"
                  )}
                </span>
              </button>
            </div>

            {(formData.contacts ||
              []).length ===
            0 ? (
              <div className="create-industry-empty-contacts">
                {t(
                  "contacts.empty"
                )}
              </div>
            ) : (
              <div className="create-industry-extra-contacts">
                {(
                  formData.contacts ||
                  []
                ).map(
                  (
                    contact,
                    index
                  ) => (
                    <div
                      key={
                        index
                      }
                      className="create-industry-extra-contact-block"
                    >
                      <div className="create-industry-extra-contact-heading">
                        <strong>
                          {t(
                            "contacts.additional_title",
                            {
                              number:
                                index +
                                1,
                            }
                          )}
                        </strong>

                        <button
                          type="button"
                          className="create-industry-remove-user-button"
                          onClick={() =>
                            handleRemoveContact(
                              index
                            )
                          }
                          title={t(
                            "contacts.actions.remove"
                          )}
                          aria-label={t(
                            "contacts.actions.remove"
                          )}
                        >
                          <FaTrashAlt />
                        </button>
                      </div>

                      <div className="create-industry-extra-contact-row">
                        <div className="create-industry-field">
                          <label>
                            {t(
                              "contacts.fields.name"
                            )}
                          </label>

                          <input
                            type="text"
                            value={
                              contact.contactName ||
                              ""
                            }
                            onChange={(
                              event
                            ) =>
                              handleContactChange(
                                index,
                                "contactName",
                                event
                                  .target
                                  .value
                              )
                            }
                            placeholder={t(
                              "contacts.placeholders.name"
                            )}
                            className="create-industry-input"
                          />
                        </div>

                        <div className="create-industry-field">
                          <label>
                            {t(
                              "contacts.fields.title"
                            )}
                          </label>

                          <input
                            type="text"
                            value={
                              contact.contactTitle ||
                              ""
                            }
                            onChange={(
                              event
                            ) =>
                              handleContactChange(
                                index,
                                "contactTitle",
                                event
                                  .target
                                  .value
                              )
                            }
                            placeholder={t(
                              "contacts.placeholders.title"
                            )}
                            className="create-industry-input"
                          />
                        </div>

                        <div className="create-industry-field">
                          <label>
                            {t(
                              "contacts.fields.email"
                            )}
                          </label>

                          <input
                            type="email"
                            value={
                              contact.contactEmail ||
                              ""
                            }
                            onChange={(
                              event
                            ) =>
                              handleContactChange(
                                index,
                                "contactEmail",
                                event
                                  .target
                                  .value
                              )
                            }
                            placeholder={t(
                              "contacts.placeholders.email"
                            )}
                            className={`create-industry-input ${
                              formErrors[
                                `contacts-${index}-contactEmail`
                              ]
                                ? "create-industry-input-error"
                                : ""
                            }`}
                          />

                          {formErrors[
                            `contacts-${index}-contactEmail`
                          ] && (
                            <p className="create-industry-field-error">
                              {
                                formErrors[
                                  `contacts-${index}-contactEmail`
                                ]
                              }
                            </p>
                          )}
                        </div>

                        <div className="create-industry-field">
                          <label>
                            {t(
                              "contacts.fields.countryCode"
                            )}
                          </label>

                          <Select
                            options={
                              phoneNumberOptions
                            }
                            value={
                              phoneNumberOptions.find(
                                (
                                  option
                                ) =>
                                  option.value ===
                                  contact.phoneNumberCountryCode
                              ) ||
                              null
                            }
                            onChange={(
                              option
                            ) =>
                              handleContactChange(
                                index,
                                "phoneNumberCountryCode",
                                option?.value ||
                                  ""
                              )
                            }
                            formatOptionLabel={(
                              option
                            ) => (
                              <div className="create-industry-option-with-icon">
                                <img
                                  src={`https://flagcdn.com/w40/${option.code}.png`}
                                  alt={
                                    option.label
                                  }
                                  className="create-industry-option-flag"
                                />

                                <span>
                                  {
                                    option.label
                                  }
                                </span>
                              </div>
                            )}
                            placeholder={t(
                              "contacts.placeholders.countryCode"
                            )}
                            styles={
                              customSelectStyles
                            }
                            classNamePrefix="create-industry-select"
                            isClearable
                          />
                        </div>

                        <div className="create-industry-field">
                          <label>
                            {t(
                              "contacts.fields.phoneNumber"
                            )}
                          </label>

                          <input
                            type="text"
                            value={
                              contact.phoneNumber ||
                              ""
                            }
                            onChange={(
                              event
                            ) =>
                              handleContactChange(
                                index,
                                "phoneNumber",
                                event
                                  .target
                                  .value
                              )
                            }
                            placeholder={t(
                              "contacts.placeholders.phoneNumber"
                            )}
                            className="create-industry-input"
                          />
                        </div>
                      </div>
                    </div>
                  )
                )}
              </div>
            )}
          </section>

          {/* =========================================
              BANKING / PAYMENT
              ========================================= */}
          <section
            ref={(
              node
            ) => {
              sectionRefs.current.billing =
                node;
            }}
            data-section="billing"
            className="create-industry-section"
          >
            <div className="create-industry-section-header">
              <span className="create-industry-section-header__icon">
                <FaCreditCard />
              </span>

              <div>
                <h2>
                  {t(
                    "nav.billing"
                  )}
                </h2>

                <p>
                  {t(
                    "section_subtitles.billing"
                  )}
                </p>
              </div>
            </div>

            <div className="create-industry-grid create-industry-grid--2">
              <div className="create-industry-field">
                <label htmlFor="accountHolderName">
                  {t(
                    "labels.accountHolderName"
                  )}
                </label>

                <input
                  type="text"
                  id="accountHolderName"
                  name="accountHolderName"
                  value={
                    formData.accountHolderName
                  }
                  onChange={
                    handleInputChange
                  }
                  placeholder={t(
                    "placeholders.accountHolderName"
                  )}
                  className="create-industry-input"
                />
              </div>

              <div className="create-industry-field">
                <label htmlFor="accountNumber">
                  {t(
                    "labels.accountNumber"
                  )}
                </label>

                <input
                  type="text"
                  id="accountNumber"
                  name="accountNumber"
                  value={
                    formData.accountNumber
                  }
                  onChange={
                    handleInputChange
                  }
                  placeholder={t(
                    "placeholders.accountNumber"
                  )}
                  className="create-industry-input"
                />
              </div>
            </div>

            <div className="create-industry-grid create-industry-grid--4">
              <div className="create-industry-field">
                <label htmlFor="bankName">
                  {t(
                    "labels.bankName"
                  )}
                </label>

                <input
                  type="text"
                  id="bankName"
                  name="bankName"
                  value={
                    formData.bankName
                  }
                  onChange={
                    handleInputChange
                  }
                  placeholder={t(
                    "placeholders.bankName"
                  )}
                  className="create-industry-input"
                />
              </div>

              <div className="create-industry-field">
                <label htmlFor="IBAN">
                  {t(
                    "labels.IBAN"
                  )}
                </label>

                <input
                  type="text"
                  id="IBAN"
                  name="IBAN"
                  value={
                    formData.IBAN
                  }
                  onChange={
                    handleInputChange
                  }
                  placeholder={t(
                    "placeholders.IBAN"
                  )}
                  className={`create-industry-input ${
                    formErrors.IBAN
                      ? "create-industry-input-error"
                      : ""
                  }`}
                />

                {formErrors.IBAN && (
                  <p className="create-industry-field-error">
                    {
                      formErrors.IBAN
                    }
                  </p>
                )}
              </div>

              <div className="create-industry-field">
                <label htmlFor="SWIFT_BIC">
                  {t(
                    "labels.SWIFT_BIC"
                  )}
                </label>

                <input
                  type="text"
                  id="SWIFT_BIC"
                  name="SWIFT_BIC"
                  value={
                    formData.SWIFT_BIC
                  }
                  onChange={
                    handleInputChange
                  }
                  placeholder={t(
                    "placeholders.SWIFT_BIC"
                  )}
                  className={`create-industry-input ${
                    formErrors.SWIFT_BIC
                      ? "create-industry-input-error"
                      : ""
                  }`}
                />

                {formErrors.SWIFT_BIC && (
                  <p className="create-industry-field-error">
                    {
                      formErrors.SWIFT_BIC
                    }
                  </p>
                )}
              </div>

              <div className="create-industry-field">
                <label>
                  {t(
                    "labels.currency"
                  )}
                </label>

                <Select
                  options={
                    currencyOptions
                  }
                  value={
                    currencyOptions.find(
                      (
                        option
                      ) =>
                        option.value ===
                        formData.currency
                    ) ||
                    null
                  }
                  onChange={(
                    option
                  ) =>
                    setFieldValue(
                      "currency",
                      option?.value ||
                        ""
                    )
                  }
                  formatOptionLabel={(
                    option
                  ) => (
                    <div className="create-industry-option-with-icon">
                      <img
                        src={`https://flagcdn.com/w40/${option.code}.png`}
                        alt={
                          option.label
                        }
                        className="create-industry-option-flag"
                      />

                      <span>
                        {
                          option.label
                        }
                      </span>
                    </div>
                  )}
                  placeholder={t(
                    "placeholders.currency"
                  )}
                  styles={
                    customSelectStyles
                  }
                  classNamePrefix="create-industry-select"
                  isClearable
                  isSearchable={
                    false
                  }
                />
              </div>
            </div>

            <div className="create-industry-grid create-industry-grid--4">
              <div className="create-industry-field">
                <label>
                  {t(
                    "labels.paymentMethodsAccepted"
                  )}
                </label>

                <Select
                  options={
                    paymentOptions
                  }
                  isMulti
                  closeMenuOnSelect={
                    false
                  }
                  hideSelectedOptions={
                    false
                  }
                  value={
                    paymentOptions.filter(
                      (
                        option
                      ) =>
                        (
                          formData.paymentMethodsAccepted ||
                          []
                        ).includes(
                          option.value
                        )
                    )
                  }
                  onChange={(
                    selected
                  ) =>
                    setFieldValue(
                      "paymentMethodsAccepted",
                      selected
                        ? selected.map(
                            (
                              option
                            ) =>
                              option.value
                          )
                        : []
                    )
                  }
                  placeholder={t(
                    "placeholders.paymentMethodsAccepted"
                  )}
                  styles={
                    multiInlineScrollStyles
                  }
                  classNamePrefix="create-industry-select"
                  isSearchable={
                    false
                  }
                />
              </div>

              <div className="create-industry-field">
                <label>
                  {t(
                    "labels.paymentDueDate"
                  )}
                </label>

                <Select
                  options={
                    paymentDueDateOptions
                  }
                  value={
                    paymentDueDateOptions.find(
                      (
                        option
                      ) =>
                        option.value ===
                        formData.paymentDueDate
                    ) ||
                    null
                  }
                  onChange={(
                    option
                  ) =>
                    setFieldValue(
                      "paymentDueDate",
                      option?.value ||
                        ""
                    )
                  }
                  placeholder={t(
                    "placeholders.paymentDueDate"
                  )}
                  styles={
                    customSelectStyles
                  }
                  classNamePrefix="create-industry-select"
                  isClearable
                  isSearchable={
                    false
                  }
                />
              </div>

              <div className="create-industry-field">
                <label>
                  {t(
                    "labels.discountTerms"
                  )}
                </label>

                <Select
                  options={[
                    ...Array(
                      21
                    ),
                  ].map(
                    (
                      _,
                      index
                    ) => ({
                      value:
                        `${index *
                        5}%`,

                      label:
                        `${index *
                        5}%`,
                    })
                  )}
                  value={
                    formData.discountTerms
                      ? {
                          value:
                            formData.discountTerms,

                          label:
                            formData.discountTerms,
                        }
                      : null
                  }
                  onChange={(
                    option
                  ) =>
                    setFieldValue(
                      "discountTerms",
                      option?.value ||
                        ""
                    )
                  }
                  placeholder={t(
                    "placeholders.discountTerms"
                  )}
                  styles={
                    customSelectStyles
                  }
                  classNamePrefix="create-industry-select"
                  isClearable
                  isSearchable={
                    false
                  }
                />
              </div>

              <div className="create-industry-field">
                <label htmlFor="latePaymentPenalties">
                  {t(
                    "labels.latePaymentPenalties"
                  )}
                </label>

                <input
                  type="text"
                  id="latePaymentPenalties"
                  name="latePaymentPenalties"
                  value={
                    formData.latePaymentPenalties
                  }
                  onChange={
                    handleInputChange
                  }
                  placeholder={t(
                    "placeholders.latePaymentPenalties"
                  )}
                  className="create-industry-input"
                />
              </div>
            </div>

            <div className="create-industry-section-divider" />

            <div className="create-industry-subsection-heading">
              <h3>
                {t(
                  "sections.invoicing_prefs"
                )}
              </h3>

              <p>
                {t(
                  "section_subtitles.invoicing"
                )}
              </p>
            </div>

            <div className="create-industry-grid create-industry-grid--3">
              <div className="create-industry-field">
                <label htmlFor="VAT_TaxInformation">
                  {t(
                    "labels.VAT_TaxInformation"
                  )}
                </label>

                <input
                  type="text"
                  id="VAT_TaxInformation"
                  name="VAT_TaxInformation"
                  value={
                    formData.VAT_TaxInformation
                  }
                  onChange={
                    handleInputChange
                  }
                  placeholder={t(
                    "placeholders.VAT_TaxInformation"
                  )}
                  className="create-industry-input"
                />
              </div>

              <div className="create-industry-field">
                <label htmlFor="iva">
                  {t(
                    "labels.iva"
                  )}
                </label>

                <input
                  type="text"
                  id="iva"
                  name="iva"
                  inputMode="decimal"
                  value={
                    formData.iva
                  }
                  onChange={
                    handleInputChange
                  }
                  placeholder={t(
                    "placeholders.iva"
                  )}
                  className={`create-industry-input ${
                    formErrors.iva
                      ? "create-industry-input-error"
                      : ""
                  }`}
                />

                {formErrors.iva && (
                  <p className="create-industry-field-error">
                    {
                      formErrors.iva
                    }
                  </p>
                )}
              </div>

              <div className="create-industry-field">
                <label>
                  {t(
                    "labels.invoiceDeliveryMethod"
                  )}
                </label>

                <Select
                  options={
                    invoiceDeliveryOptions
                  }
                  value={
                    invoiceDeliveryOptions.find(
                      (
                        option
                      ) =>
                        option.value ===
                        formData.invoiceDeliveryMethod
                    ) ||
                    null
                  }
                  onChange={(
                    option
                  ) =>
                    setFieldValue(
                      "invoiceDeliveryMethod",
                      option?.value ||
                        ""
                    )
                  }
                  placeholder={t(
                    "placeholders.invoiceDeliveryMethod"
                  )}
                  styles={
                    customSelectStyles
                  }
                  classNamePrefix="create-industry-select"
                  isClearable
                  isSearchable={
                    false
                  }
                />
              </div>
            </div>
            <div className="create-industry-grid create-industry-grid--1">
              <div className="create-industry-field">
                <label htmlFor="additionalNotes">
                  {t(
                    "labels.additionalNotes"
                  )}
                </label>

                <textarea
                  id="additionalNotes"
                  name="additionalNotes"
                  value={
                    formData.additionalNotes ||
                    ""
                  }
                  onChange={
                    handleInputChange
                  }
                  placeholder={t(
                    "placeholders.additionalNotes"
                  )}
                  rows="4"
                  maxLength="500"
                  className="create-industry-textarea"
                />

                <div className="create-industry-character-counter">
                  {(
                    formData.additionalNotes ||
                    ""
                  ).length}{" "}
                  / 500
                </div>
              </div>
            </div>
          </section>
        </form>
      </div>
    </div>
  );
}